import { render, staticRenderFns } from "./ConsultarAutorizacaoFornecimentoForm.vue?vue&type=template&id=71230918"
import script from "./ConsultarAutorizacaoFornecimentoForm.vue?vue&type=script&lang=js"
export * from "./ConsultarAutorizacaoFornecimentoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports